(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name trainingCostReport.controller:TrainingCostReportCtrl
   *
   * @description
   *
   */
  angular
    .module('trainingCostReport')
    .controller('TrainingCostReportCtrl', TrainingCostReportCtrl);

  function TrainingCostReportCtrl(CommonMasterData, $sce,CommonLogicService,RemoteService,ApplicationService) {
    var vm = this;
    vm.ctrlName = 'TrainingCostReportCtrl';
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        locationList : null,
        hubList : null,
        trainingCategories : null,
        instructorsList : null,
        currency:null
      },
      masterList : {
        locationList : [],
        hubList : [],
        trainingCategories : [],
        instructorsList : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        isToDateFutureDate : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };
    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchTrainingCost(params);
    };

    // on change search field
    vm.changeSearchField = function(searchParams, flag) {
      if(flag == 'fromDate'){
        var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
        if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
          searchParams.toDate = tempFromDate;
        }
      }
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.isToDateFutureDate) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.isToDateFutureDate = false;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
        if (!!vm.model.searchCriteria.toDate) {
          vm.model.masterList.isToDateFutureDate = istoDateFutureDate();
        } else {
          vm.model.masterList.isToDateFutureDate = false;
        }
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    // check to date is a future date
    function istoDateFutureDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isAfter(moment().toDate());
    };

    // search Training Cost Report
    function searchTrainingCost(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
     //   vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var url = CommonLogicService.getReportUrl(
          'training_cost_report.rptdesign',
          getSearchParamMap(vm.model.searchCriteria));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);

      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["userName"] = ApplicationService.getLoginInfo().userName;
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
        searchParamMap["crewIds"]=Object.keys(param.instructorsList).map(function(k){return param.instructorsList[k].crewId}).join(",");
      searchParamMap["trainingTypes"] = Object.keys(param.trainingCategories).map(function(k){return param.trainingCategories[k].categoryCode}).join(",");
      searchParamMap["airlines"] = Object.keys(param.hubList).map(function(k){return param.hubList[k].airlineaName}).join(",");
      searchParamMap["locations"] = Object.keys(param.locationList).map(function(k){return param.locationList[k].trainingLocationCode}).join(",");
      searchParamMap["currency"] = param.currency;

      return searchParamMap;
    }
    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid
        || vm.model.masterList.isToDateFutureDate) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        return true;
      }
    }
    function adaptInstructorList(instructorList) {
     for(var i in instructorList){
       instructorList[i].instructorName = instructorList[i].firstName + " " +instructorList[i].lastName +"-"+instructorList[i].crewId;
      }
      return instructorList;
    }

    CommonMasterData.getAllTrainingCategories(function (categoryList) {
      vm.model.masterList.trainingCategories = categoryList;
    }, function (error) {
    });

     RemoteService.loadTrainingLocationByStation("").then(
      function (response) {
        vm.model.masterList.locationList = response.locationList;
        successFn( vm.model.masterList.locationList);
      },
      function (error) {
        errorFn(error)
      }
    );
    CommonMasterData.loadInstructorList(function (response) {
        vm.model.masterList.instructorsList = adaptInstructorList(response);
      },
      function () {
      console.log('Crew list retrieval error');
      }
    );
    CommonMasterData.loadAirlineList(true,function (response) {
        vm.model.masterList.hubList = response;
      },
      function () {
        console.log('Crew list retrieval error');
      }
    );
    
    CommonMasterData.getCurrency(function(currency) {
		vm.model.searchCriteria.currency = currency;
	}, function() {
		console.log('Currency retrieval error');
	});


  }
}());
